export const UPDATE_TIMEZONE = 'redux-oidc/UPDATE_TIMEZONE';

interface UpdateTimezoneAction {
    type: typeof UPDATE_TIMEZONE
    payload: string
}


export type oidcActionTypes = UpdateTimezoneAction